import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Maubaocao18 from "components/Tonghopbaocao/Maubaocao18/Maubaocao18.js";
export default function BCmau18() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Kết quả hoạt động vận chuyển hành khách (Phụ lục XIV)",
            tabContent: <Maubaocao18 />,
          },
        ]}
      />
    </div>
  );
}
